import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import AdminDashboard from './pages/AdminDashboard';
import AdminCatalog from './pages/AdminCatalog';
import AdminProblematiques from './pages/AdminProblematiques';
import AdminEmployees from './pages/AdminEmployees';
import AdminClients from './pages/AdminClients';
import AdminFeedbacks from './pages/AdminFeedbacks';
import Login from './pages/Login';
import { AppProvider } from './context/AppContext';
import Layout from './components/Layout';

const ProtectedRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const token = localStorage.getItem('token');
  if (!token) {
    return <Navigate to="/login" replace />;
  }
  return <>{children}</>;
};

function App() {
  return (
    <AppProvider>
      <Router>
        <Layout>
          <Routes>
            <Route path="/" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
            <Route path="/login" element={<Login />} />
            <Route path="/admin" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
            <Route path="/admin/catalogue" element={<ProtectedRoute><AdminCatalog /></ProtectedRoute>} />
            <Route path="/admin/problematiques" element={<ProtectedRoute><AdminProblematiques /></ProtectedRoute>} />
            <Route path="/admin/employes" element={<ProtectedRoute><AdminEmployees /></ProtectedRoute>} />
            <Route path="/admin/clients" element={<ProtectedRoute><AdminClients /></ProtectedRoute>} />
            <Route path="/admin/feedbacks" element={<ProtectedRoute><AdminFeedbacks /></ProtectedRoute>} />
          </Routes>
        </Layout>
      </Router>
    </AppProvider>
  );
}

export default App;
